import CustomProgressCircle from './CustomProgressCircle';

export default CustomProgressCircle;
